/**
 * Semantic report icon keys (API contract §5) → Tabler icons. The API never
 * names an icon library; it sends a stable key and the portal owns the
 * mapping. The design handoff's Lucide names map onto these Tabler
 * equivalents (Receipt → IconReceipt, UsersRound → IconUsers, …).
 */
import type { TablerIcon } from "@tabler/icons-react";
import {
  IconAward,
  IconBriefcase,
  IconCalendar,
  IconCalendarStats,
  IconCashRegister,
  IconFileAnalytics,
  IconGift,
  IconHistory,
  IconListDetails,
  IconPackage,
  IconReceipt,
  IconScissors,
  IconShoppingBag,
  IconSparkles,
  IconUserDollar,
  IconUsers,
} from "@tabler/icons-react";

export const REPORT_ICONS: Readonly<Record<string, TablerIcon>> = {
  calendar: IconCalendar,
  "calendar-stats": IconCalendarStats,
  receipt: IconReceipt,
  users: IconUsers,
  briefcase: IconBriefcase,
  history: IconHistory,
  "user-dollar": IconUserDollar,
  "cash-register": IconCashRegister,
  scissors: IconScissors,
  "shopping-bag": IconShoppingBag,
  package: IconPackage,
  "list-details": IconListDetails,
  gift: IconGift,
  award: IconAward,
  sparkles: IconSparkles,
};

/** Generic icon for an unknown or missing key. */
export const DEFAULT_REPORT_ICON: TablerIcon = IconFileAnalytics;

export function reportIcon(key: string | null | undefined): TablerIcon {
  return (key && REPORT_ICONS[key]) || DEFAULT_REPORT_ICON;
}
